module.exports = __webpack_public_path__ + "img/user20.bb0d23aa.jpg";